import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";

// Hotfix Auth-Consolidation (10.02.2026) — Boardroom-CoS-Directive:
// Magic-Link-Only-Auth. Die frühere Passwort-Registrierung
// (Register.jsx v1) wurde vollständig entfernt. Diese Route dient nur
// noch als 301-artige Umleitung auf die LandingPage, wo das LoginModal
// im mode="optin" (Magic-Link via Resend) geöffnet wird.
//
// Query-Parameter Fokustyp + Source werden erhalten, damit der
// Quick-Check-Carry-Over aus Sprint 11.6 weiter funktioniert. Direkte
// /register-Aufrufe (alte Bookmarks, externe Links, SEO-Traffic) landen
// zwingend im Magic-Link-Flow — kein Passwort-Dialog mehr.
export default function Register() {
  const [searchParams] = useSearchParams();
  const next = new URLSearchParams();
  next.set("open", "magic-optin");
  const ft = (searchParams.get("fokustyp") || "").toLowerCase().trim();
  if (["eule", "biene", "katze", "hund"].includes(ft)) {
    next.set("fokustyp", ft);
  }
  const src = (searchParams.get("source") || "").trim();
  if (src) {
    next.set("source", src);
  } else {
    next.set("source", "register_redirect");
  }
  return <Navigate to={`/?${next.toString()}`} replace />;
}
